import { render } from "./InscriptionsList.vue?vue&type=template&id=29777542"
import script from "./InscriptionsList.vue?vue&type=script&lang=js"
export * from "./InscriptionsList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__